/* ==========================================================================
   VETMA — Tiroir de panier
   Suppression d'un article, avec rafraîchissement du tiroir.
   ========================================================================== */

(function () {
  'use strict';

  /* Le fetch d'origine, capture avant tout patch : nos propres appels
     ne doivent pas redeclencher la synchronisation. */
  var rawFetch = window.fetch.bind(window);

  /* Sections que le thème redessine après un changement */
  var CART_SECTIONS = 'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';

  /* Prévient le thème et met à jour le compteur du header */
  function refreshCart(response) {
    window.dispatchEvent(
      new CustomEvent('switch:cart:afteradditem', {
        detail: { response: response }
      })
    );

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      if (typeof response.item_count === 'number') {
        el.textContent = response.item_count;
        el.classList.toggle('is-empty', response.item_count === 0);
      }
    });
  }

  /* ----------------------------------------------------------------------
     Cadeau offert
     Un seul endroit decide : si le panier contient un produit eligible,
     le cadeau doit y etre ; sinon il ne doit pas y etre. La regle est
     rejouee au chargement de page, donc le cadeau survit a une
     actualisation.
     ---------------------------------------------------------------------- */

  var GIFT = window.VetmaGift || {};

  /* Les identifiants produits qui donnent droit au cadeau. */
  var GIFT_FOR = String(GIFT.eligible || '')
    .split(',')
    .map(function (h) { return h.trim(); })
    .filter(Boolean);

  /* Une ligne marquee _gift est un cadeau, quel que soit son libelle :
     l'ancien systeme ecrivait 'true', le nouveau ecrit le libelle. */
  function isGiftLine(line) {
    return !!(line.properties && line.properties._gift);
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftLine(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function hasEligible(cart) {
    return cart.items.some(function (line) {
      if (isGiftLine(line)) return false;
      /* product_handle est le champ fiable ; handle existe aussi
         mais peut porter la variante selon le contexte. */
      var h = line.product_handle || line.handle || '';
      return GIFT_FOR.indexOf(h) > -1;
    });
  }

  var syncing = false;

  function syncGift(onDone) {
    /* Sans cadeau configure, il n'y a rien a synchroniser. */
    if (syncing || !GIFT.variantId || !GIFT_FOR.length) {
      if (onDone) onDone(false);
      return;
    }

    syncing = true;

    rawFetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wanted = hasEligible(cart);
        var current = giftLine(cart);

        if (wanted && !current) {
          return rawFetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{
                id: GIFT.variantId,
                quantity: 1,
                properties: { _gift: GIFT.label || 'Free gift' }
              }],
              sections: CART_SECTIONS
            })
          }).then(function (r) { return r.json(); }).then(function () { return true; });
        }

        if (!wanted && current) {
          return rawFetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: current.key, quantity: 0, sections: CART_SECTIONS })
          }).then(function (r) { return r.json(); }).then(function () { return true; });
        }

        return false;
      })
      .catch(function () { return false; })
      .then(function (changed) {
        syncing = false;
        if (onDone) onDone(changed);
      });
  }

  /* Au chargement : on remet le panier d'aplomb avant que le tiroir
     ne soit dessine, pour eviter qu'il clignote. */
  function syncOnLoad() {
    syncGift(function (changed) {
      if (!changed) return;

      rawFetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });

          ['cart:refresh', 'cart:build', 'cart:updated', 'cart:change'].forEach(function (ev) {
            try {
              document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
            } catch (err) {}
          });
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOnLoad);
  } else {
    syncOnLoad();
  }

  /* Apres toute action panier du theme, on rejoue la regle. */
  var themeFetch = window.fetch;

  window.fetch = function () {
    var args = arguments;
    var url = (args[0] && args[0].url) ? args[0].url : String(args[0]);

    return themeFetch.apply(this, args).then(function (res) {
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !syncing) {
        setTimeout(function () { syncGift(function () {}); }, 80);
      }
      return res;
    });
  };

  /* ----------------------------------------------------------------------
     Suggestion : ajout sans quitter la page
     ---------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-suggest-form')) return;

    e.preventDefault();

    var btn = form.querySelector('button');
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = '...';
    }

    var items = [{ id: form.querySelector('input[name="id"]').value, quantity: 1 }];

    /* On ajoute le produit ; le cadeau est ensuite pose par syncGift,
       qui est seul a decider de sa presence. */
    rawFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: CART_SECTIONS })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        return new Promise(function (resolve) {
          syncGift(function () { resolve(response); });
        });
      })
      .then(function (response) {
        /* Le panier renvoyé par cart/add n'a pas item_count : on le relit.
           Les sections sont relues aussi, le cadeau venant d'arriver. */
        return rawFetch(window.Shopify.routes.root +
                        '?sections=' + encodeURIComponent(CART_SECTIONS))
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            response.sections = sections;
            return rawFetch(window.Shopify.routes.root + 'cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                response.item_count = cart.item_count;
                refreshCart(response);
              });
          });
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
        form.submit();
      });
  });

  /* L'écoute est posée sur le document en phase de capture : le tiroir est
     redessiné régulièrement, et le clic peut tomber sur l'icône du bouton. */
  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      var btn = null;

      /* Remonte depuis l'élément cliqué jusqu'au bouton */
      while (target && target !== document) {
        if (target.hasAttribute && target.hasAttribute('data-remove-key')) {
          btn = target;
          break;
        }
        target = target.parentNode;
      }

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      var key = btn.getAttribute('data-remove-key');
      var item = btn.closest ? btn.closest('.v-dcart__item') : null;
      if (item) item.classList.add('is-busy');

      rawFetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0, sections: CART_SECTIONS })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          /* Cette suppression passe par rawFetch pour eviter les boucles :
             le patch de window.fetch ne la voit pas. On rejoue donc la
             regle du cadeau a la main, sinon retirer le livre laisserait
             le Vetmeter seul au panier. */
          return new Promise(function (resolve) {
            syncGift(function (changed) {
              if (!changed) { resolve(response); return; }

              /* Le cadeau vient de partir : les sections renvoyees
                 plus haut sont perimees, on les relit. */
              rawFetch(window.Shopify.routes.root +
                       '?sections=' + encodeURIComponent(CART_SECTIONS))
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  return rawFetch(window.Shopify.routes.root + 'cart.js')
                    .then(function (r) { return r.json(); })
                    .then(function (cart) {
                      response.sections = sections;
                      response.item_count = cart.item_count;
                      resolve(response);
                    });
                })
                .catch(function () { resolve(response); });
            });
          });
        })
        .then(function (response) {
          /* Le thème écoute cet événement pour redessiner ses sections */
          window.dispatchEvent(
            new CustomEvent('switch:cart:afteradditem', {
              detail: { response: response }
            })
          );

          /* Met à jour le compteur du header */
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = response.item_count;
            el.classList.toggle('is-empty', response.item_count === 0);
          });

          /* Sans section renvoyée, on recharge pour rester cohérent */
          if (!response.sections) window.location.reload();
        })
        .catch(function () {
          if (item) item.classList.remove('is-busy');
          window.location.reload();
        });
    },
    true
  );
})();
